<script>
    /**
     * @typedef {'equal' | 'remove' | 'add'} DiffType
     *
     * @typedef {{
     *     type: DiffType,
     *     value: string,
     * }} DiffPart
     *
     * @typedef {{
     *     type: DiffType,
     *     text: string,
     *     inline?: DiffPart[],
     * }} DiffLine
     */

    /** @type {{ lines?: DiffLine[] }} */
    let { lines = [] } = $props();

    /**
     * @param {string} str
     * @returns {string}
     */
    function escapeHtml(str) {
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /**
     * @param {DiffLine} line
     * @returns {string}
     */
    function renderLineHtml(line) {
        if (line.inline) {
            return line.inline
                .map((part) => {
                    const escaped = escapeHtml(part.value);

                    if (part.type === 'equal') {
                        return escaped;
                    }

                    const cls = part.type === 'add' ? 'lyDiffWord--add' : 'lyDiffWord--remove';

                    return `<span class="${cls}">${escaped}</span>`;
                })
                .join('');
        }

        const escaped = escapeHtml(line.text);

        return escaped === '' ? '&nbsp;' : escaped;
    }

    const renderedLines = $derived(lines.map((line) => ({ ...line, html: renderLineHtml(line) })));

    /**
     * @param {DiffType} type
     * @returns {string}
     */
    const markerOf = (type) => (type === 'add' ? '+' : type === 'remove' ? '-' : '\u00A0');
</script>

<div class="lyDiffView border-black-300 w-full overflow-x-auto rounded-sm border bg-white font-mono text-sm">
    {#each renderedLines as line}
        <!-- prettier-ignore -->
        <div class="lyDiffLine lyDiffLine--{line.type} flex whitespace-pre-wrap break-words px-2 py-0.5"><span
            class="lyDiffLine__marker mr-2 inline-block w-3 select-none text-center opacity-60">{markerOf(line.type)}</span><span
            class="lyDiffLine__text">{@html line.html}</span></div>
    {/each}
</div>

<style>
    .lyDiffLine--equal {
        color: #444;
    }

    .lyDiffLine--remove {
        background: #fdecea;
    }

    .lyDiffLine--add {
        background: #e6f4ea;
    }

    :global(.lyDiffWord--remove) {
        background: #f3b4ac;
        text-decoration: line-through;
    }

    :global(.lyDiffWord--add) {
        background: #a8dab5;
    }
</style>
